// src/pages/DCAPage.jsx
import React from "react";
import LearnMoreLayout from "./components/ui/LearnMoreLayout"; // Adjust the import path as necessary

export default function DCAPage() {
  const sections = [
    {
      id: "what-is-dca",
      title: "What DCA Bot is?",
      navLabel: "What is DCA Bot",
      content: (
        <p className="text-[#585F72]">
          The Xenorize DCA Bot helps you build a position over time instead of
          buying all at once. It automatically spreads your entries into
          multiple buys as the market moves, helping smooth out your average
          entry price.
        </p>
      ),
    },
    {
      id: "how-it-trades",
      title: "How It Trades (High Level)",
      navLabel: "How It Trades (High Level)",
      content: (
        <ul className="list-disc pl-5 space-y-2 text-[#585F72]">
          <li>
            Follows a coin’s price and buys in chunks when your conditions are
            met.
          </li>
          <li>Adjusts your average buy price as new orders are filled.</li>
          <li>
            Includes a built-in take-profit feature to help you lock in gains
            when the market jumps.
          </li>
        </ul>
      ),
    },
    {
      id: "why-different",
      title: "Why It’s Different?",
      navLabel: "Why It’s Different",
      content: (
        <ul className="list-disc pl-5 space-y-2 text-[#585F72]">
          <li>
            <span className="font-bold">Price-driven</span> – not purely
            time-driven – reacts to meaningful price moves instead of just
            buying on a fixed schedule.
          </li>
          <li>
            <span className="font-bold">Take-profit aware</span> – doesn’t just
            accumulate forever; it also has rules to secure profit.
          </li>
          <li>
            <span className="font-bold">Capital-controlled</span> – you choose
            Trade Size and the maximum number of orders.
          </li>
        </ul>
      ),
    },
    {
      id: "key-benefits",
      title: "Key Benefits for Users",
      navLabel: "Key Benefits for Users",
      content: (
        <ul className="list-disc pl-5 space-y-2 text-[#585F72]">
          <li>Reduces the stress of picking a single “perfect” entry price.</li>
          <li>Automatically buys more when conditions match your plan.</li>
          <li>
            Helps lock in profit on sudden pumps, even if you’re not watching
            the chart.
          </li>
        </ul>
      ),
    },
  ];

  return (
    <LearnMoreLayout
      title="DCA"
      breadcrumb={[
        // NOTE: The layout component should handle prepending 'Home'.
        // We are following your structure here, but remember the previous conversation about duplicate 'Home' labels!
        { label: "Home", onClick: () => (window.location.href = "/") },
        { label: "DCA" },
      ]}
      sections={sections}
    />
  );
}
